<label for="upload-btn-{{id}}" class="btn btn-success" style="width:100%; margin-bottom: 0; overflow: hidden;
text-overflow: ellipsis;">
    {{text}}
  </label>  
<input type="file" class="inputfile inputfile-3"
  name="upload-btn-{{id}}" id="upload-btn-{{id}}" 
  accept="{{accept}}"
  [attr.multiple]="multiple == true ? '' : null"
  (change)="setFiles($event);">